export const LOAD_PAYMENT_METHODS = 'LOAD_PAYMENT_METHODS'
export const LOAD_PAYMENT_METHODS_SUCCESS = 'LOAD_PAYMENT_METHODS_SUCCESS'
export const LOAD_PAYMENT_METHODS_FAILED = 'LOAD_PAYMENT_METHODS_FAILED'

export const LOAD_PAYMENT_METHOD = 'LOAD_PAYMENT_METHOD'
export const LOAD_PAYMENT_METHOD_SUCCESS = 'LOAD_PAYMENT_METHOD_SUCCESS'
export const LOAD_PAYMENT_METHOD_FAILED = 'LOAD_PAYMENT_METHOD_FAILED'

export const CREATE_PAYMENT_METHOD = 'CREATE_PAYMENT_METHOD'
export const CREATE_PAYMENT_METHOD_SUCCESS = 'CREATE_PAYMENT_METHOD_SUCCESS'
export const CREATE_PAYMENT_METHOD_FAILED = 'CREATE_PAYMENT_METHOD_FAILED'

export const UPDATE_PAYMENT_METHOD = 'UPDATE_PAYMENT_METHOD'
export const UPDATE_PAYMENT_METHOD_SUCCESS = 'UPDATE_PAYMENT_METHOD_SUCCESS'
export const UPDATE_PAYMENT_METHOD_FAILED = 'UPDATE_PAYMENT_METHOD_FAILED'

export const DELETE_PAYMENT_METHOD = 'DELETE_PAYMENT_METHOD'
export const DELETE_PAYMENT_METHOD_SUCCESS = 'DELETE_PAYMENT_METHOD_SUCCESS'
export const DELETE_PAYMENT_METHOD_FAILED = 'DELETE_PAYMENT_METHOD_FAILED'

export const LOAD_ALL_PAYMENT_METHODS = 'LOAD_ALL_PAYMENT_METHODS'
export const LOAD_ALL_PAYMENT_METHODS_SUCCESS = 'LOAD_ALL_PAYMENT_METHODS_SUCCESS'
export const LOAD_ALL_PAYMENT_METHODS_FAILED = 'LOAD_ALL_PAYMENT_METHODS_FAILED'
